export const AuthState = {
  ConfirmSignIn: "confirmSignIn",
  ConfirmSignUp: "confirmSignUp",
  ForgotPassword: "forgotPassword",
  Greetings: "greetings",
  Loading: "loading",
  RequireNewPassword: "requireNewPassword",
  SignIn: "signIn",
  SignUp: "signUp",
  SignedIn: "signedIn",
  TotpSetup: "totpSetup",
  VerifyContact: "verifyContact",
} as const;

export const AuthChallenge = {
  RequireNewPassword: "NEW_PASSWORD_REQUIRED",
};
